import { Dispatch } from 'redux'
import { toast } from 'react-toastify'

import { File } from '../../lib/interfaces/File.interface'
import { Employee } from '../../lib/interfaces/Employee.interface'
import { EmployeeComment } from '../../lib/interfaces/EmployeeComment.interface'

import {
  actionTypes,
  fetchEmployeeError,
  fetchEmployeeFiles,
  EmployeeFetchAction,
  fetchEmployeesError,
  updateEmployeeError,
  EmployeeUpdateAction,
  EmployeesFetchAction,
  fetchEmployeeSuccess,
  fetchEmployeesSuccess,
  updateEmployeeSuccess,
  setCurrentEmployeeError,
  uploadEmployeeFileError,
  EmployeeFetchFilesAction,
  EmployeeUploadFileAction,
  fetchEmployeeFilesFailed,
  postEmployeeCommentError,
  EmployeePostCommentAction,
  fetchEmployeeFilesSuccess,
  EmployeesSetCurrentAction,
  setCurrentEmployeeSuccess,
  uploadEmployeeFileSuccess,
  fetchEmployeeCommentsError,
  postEmployeeCommentSuccess,
  EmployeeFetchCommentsAction,
  fetchEmployeeCommentsSuccess
} from './actions'

import {
  getEmployee,
  getEmployees,
  updateEmployee,
  getEmployeeFiles,
  uploadEmployeeFile,
  getEmployeeComments,
  postEmployeeComment
} from '../../lib/api/employees'

const { createLogic } = require('redux-logic')

const get = require('lodash/get')

type OnDoneType = () => void

const onFetchEmployeesLogic = createLogic({
  type: actionTypes.EMPLOYEES_FETCH_LIST,
  process({ action }: { action: EmployeesFetchAction }, dispatch: Dispatch, done: OnDoneType) {
    getEmployees(action.payload.filterParams)
      .then((employees: Employee[]) => dispatch(fetchEmployeesSuccess(employees)))
      .catch((err) => dispatch(fetchEmployeesError(err)))
      .then(() => done())
  },
})

const onFetchEmployeeLogic = createLogic({
  type: actionTypes.EMPLOYEE_FETCH,
  process({ action }: { action: EmployeeFetchAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next, employeeId } = action.payload
    getEmployee(employeeId)
      .then((employee: Employee) => {
        dispatch(fetchEmployeeSuccess(employee))

        if (next) {
          next(null, employee)
        }
      })
      .catch((err) => {
        dispatch(fetchEmployeeError(err))

        if (next) {
          next(err)
        }
      })
      .then(() => done())
  }
})

const onFetchEmployeFilesLogic = createLogic({
  type: actionTypes.EMPLOYEE_FETCH_FILES,
  process({ action }: { action: EmployeeFetchFilesAction }, dispatch: Dispatch, done: OnDoneType) {
    const { employeeId } = action.payload
    
    getEmployeeFiles(employeeId)
      .then((files: File[]) => dispatch(fetchEmployeeFilesSuccess(files, employeeId)))
      .catch(err => dispatch(fetchEmployeeFilesFailed(err)))
      .then(done)
  }
})

const onUploadEmployeeFileLogic = createLogic({
  type: actionTypes.EMPLOYEE_UPLOAD_FILE,
  process({ action }: { action: EmployeeUploadFileAction }, dispatch: Dispatch, done: OnDoneType) {
    const { file, employeeId, confidential } = action.payload
    uploadEmployeeFile(employeeId, file, confidential)
      .then(() => {
        dispatch(uploadEmployeeFileSuccess())
        dispatch(fetchEmployeeFiles(employeeId))
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.error', 'Error uploading the file. Please try again')
        dispatch(uploadEmployeeFileError(errorMessage))
        toast.error(errorMessage)
      })
      .then(done)
  }
})

const onSetCurrentEmployeeLogic = createLogic({
  type: actionTypes.EMPLOYEES_SET_CURRENT,
  process({ action }: { action: EmployeesSetCurrentAction }, dispatch: Dispatch, done: OnDoneType) {
    const { employee } = action.payload

    if (!employee) {
      return done()
    }

    getEmployee(employee.id)
      .then((fetchedEmployee: Employee) => dispatch(setCurrentEmployeeSuccess(fetchedEmployee)))
      .catch((err) => dispatch(setCurrentEmployeeError(err)))
      .then(() => done())
  }
})

const onPostEmployeeCommentLogic = createLogic({
  type: actionTypes.EMPLOYEE_POST_COMMENT,
  process({ action }: { action: EmployeePostCommentAction }, dispatch: Dispatch, done: OnDoneType) {
    postEmployeeComment(action.payload.employeeId, action.payload.comment)
      .then((comment: EmployeeComment) => dispatch(postEmployeeCommentSuccess(action.payload.employeeId, comment)))
      .catch(err => {
        const errorMessage = get(err, 'response.data.error', 'Error posting the comment. Please try again')
        toast.error(errorMessage)
        dispatch(postEmployeeCommentError(errorMessage))
      })
      .then(done)
  }
})

const onFetchEmployeeCommentsLogic = createLogic({
  type: actionTypes.EMPLOYEE_FETCH_COMMENTS,
  process({ action }: { action: EmployeeFetchCommentsAction }, dispatch: Dispatch, done: OnDoneType) {
    const { employeeId } = action.payload

    getEmployeeComments(employeeId)
      .then((comments: EmployeeComment[]) => dispatch(fetchEmployeeCommentsSuccess(employeeId, comments)))
      .catch(err => dispatch(fetchEmployeeCommentsError(err)))
      .then(done)
  }
})

const onUpdateEmployeeLogic = createLogic({
  type: actionTypes.EMPLOYEE_UPDATE,
  process({ action }: { action: EmployeeUpdateAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next, employee, employeeId } = action.payload

    updateEmployee(employeeId, employee)
      .then((updatedEmployee: Employee) => {
        dispatch(updateEmployeeSuccess(updatedEmployee))
        toast.success('Employee successfully updated')

        if (next) {
          next(null, updatedEmployee)
        }
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.message', 'Error updating employee. Please try again')
        dispatch(updateEmployeeError(errorMessage))
        toast.error(errorMessage)

        if (next) {
          next(err)
        }
      })
      .then(done)
  }
})

export const employeesLogic = [
  onFetchEmployeesLogic,
  onFetchEmployeeLogic,
  onFetchEmployeFilesLogic,
  onUploadEmployeeFileLogic,
  onSetCurrentEmployeeLogic,
  onPostEmployeeCommentLogic,
  onFetchEmployeeCommentsLogic,
  onUpdateEmployeeLogic
]



// WEBPACK FOOTER //
// ./src/store/employees/logic.ts